// Studio-Theme: Verhalten im ganzen Shop. Ohne Bibliotheken; Motion (window.Motion) nur, wenn vorhanden.
(() => {
  const reduceMotion = {
    get matches() {
      return window.siteReducedMotion
        ? window.siteReducedMotion()
        : window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    },
  };
  const isPreview = Boolean(window.SITE_VORSCHAU);
  const liveRegion = () => document.querySelector('[data-live-region]');
  const announce = (text) => {
    const region = liveRegion();
    if (!region) return;
    region.textContent = '';
    window.setTimeout(() => (region.textContent = text), 50);
  };

  /* ---------- Menü am Handy ---------- */
  document.querySelectorAll('[data-menu-drawer]').forEach((drawer) => {
    const close = () => drawer.removeAttribute('open');
    drawer.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer.open) {
        close();
        drawer.querySelector('summary')?.focus();
      }
    });
    document.addEventListener('click', (event) => {
      if (drawer.open && !drawer.contains(event.target)) close();
    });
    window.matchMedia('(min-width: 990px)').addEventListener('change', close);
  });

  /* ---------- Mengenfeld ---------- */
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-quantity-step]');
    if (!button) return;
    const input = button.closest('.quantity')?.querySelector('input');
    if (!input) return;
    const step = Number(button.dataset.quantityStep);
    const min = Number(input.min || 0);
    const next = Math.max(min, (Number(input.value) || 0) + step);
    input.value = String(next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Warenkorb-Zähler ---------- */
  const setCartCount = (count) => {
    document.querySelectorAll('[data-cart-count]').forEach((badge) => {
      badge.hidden = count === 0;
      const number = badge.querySelector('[data-cart-count-number]');
      if (number) number.textContent = String(count);
    });
  };

  /* ---------- In den Warenkorb (ohne Seitenwechsel) ---------- */
  document.addEventListener('submit', async (event) => {
    const wrapper = event.target.closest('[data-product-form]');
    if (!wrapper) return;
    const form = event.target;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    const message = wrapper.querySelector('[data-form-message]');
    const show = (text, kind) => {
      if (!message) return;
      message.hidden = false;
      message.className = `form-message form-message--${kind}`;
      message.innerHTML = text;
    };
    if (!form.reportValidity()) {
      // die Blase des Browsers verschwindet schnell, die Meldung bleibt unter dem Knopf stehen (z. B. Wunschtermin)
      const field = [...form.elements].find((el) => el.willValidate && !el.validity.valid);
      if (field) show(field.validationMessage, 'error');
      return;
    }

    if (isPreview) {
      show('In der Vorschau gibt es keinen echten Warenkorb. Im Shop landet das Produkt jetzt im Warenkorb.', 'success');
      announce('Vorschau: kein echter Warenkorb.');
      return;
    }

    button?.setAttribute('aria-busy', 'true');
    button?.setAttribute('disabled', '');
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || '');
      const cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then((r) => r.json());
      setCartCount(cart.item_count);
      const added = wrapper.dataset.addedText;
      show(`${added} <a href="${wrapper.dataset.cartUrl}">${wrapper.dataset.cartLink}</a>`, 'success');
      announce(added);
    } catch (error) {
      show(error.message || wrapper.dataset.errorText, 'error');
      announce(error.message || wrapper.dataset.errorText);
    } finally {
      button?.removeAttribute('aria-busy');
      button?.removeAttribute('disabled');
    }
  });

  /* ---------- Varianten (Federbreite, Lineatur) ---------- */
  const formatMoney = (cents) =>
    new Intl.NumberFormat('de-DE', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' }).format(cents / 100);

  document.querySelectorAll('[data-variant-picker]').forEach((picker) => {
    const root = picker.closest('[data-product]');
    const variants = JSON.parse(root.querySelector('[data-variants-json]')?.textContent || '[]');
    const idInput = root.querySelector('input[name="id"]');
    const priceEl = root.querySelector('[data-price]');
    const unitEl = root.querySelector('[data-unit-price]');
    const submit = root.querySelector('[data-product-form] [type="submit"]');

    picker.addEventListener('change', () => {
      const selected = Array.from(picker.querySelectorAll('input:checked')).map((input) => input.value);
      const variant = variants.find((v) => v.options.every((value, i) => value === selected[i]));
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      // Preise kommen fertig formatiert aus Liquid (money), damit sie dem Währungsformat des Shops folgen
      if (priceEl) priceEl.textContent = variant.price_html || formatMoney(variant.price);
      if (unitEl && variant.unit_price) unitEl.textContent = variant.unit_html || formatMoney(variant.unit_price);
      if (submit) {
        submit.disabled = !variant.available;
        const label = submit.querySelector('.button__label');
        if (label) {
          label.textContent = variant.available ? submit.dataset.labelAvailable : submit.dataset.labelSoldOut;
          label.dataset.text = label.textContent;
        }
      }
      if (!isPreview && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
      root.dispatchEvent(new CustomEvent('site:variant', { detail: { variant, selected } }));
    });
  });

  /* ---------- Konfiguration der Pakete ---------- */
  document.querySelectorAll('[data-config]').forEach((config) => {
    const selects = config.querySelectorAll('[data-config-select]');
    const farbe = config.querySelector('[data-config-farbe]');
    const swatchBox = config.querySelector('[data-config-swatches]');
    const update = () => {
      const open = Array.from(selects).map((select) => select.selectedOptions[0]?.dataset.extra).filter(Boolean);
      config.querySelectorAll('[data-config-show]').forEach((box) => {
        const show = open.includes(box.dataset.configShow);
        box.hidden = !show;
        box.querySelectorAll('input, textarea, select').forEach((field) => (field.disabled = !show));
      });
      const colors = (farbe?.selectedOptions[0]?.dataset.colors || '').split(',').filter(Boolean);
      swatchBox?.querySelectorAll('i').forEach((dot, i) => (dot.style.background = colors[i] || 'transparent'));
      swatchBox?.classList.toggle('is-empty', !colors.length);
    };
    selects.forEach((select) => select.addEventListener('change', update));
    update();
  });

  /* ---------- Chips mit Einzelauswahl: nochmal klicken hebt die Auswahl auf ---------- */
  document.addEventListener('click', (event) => {
    const chip = event.target.closest('label.bk__chip');
    const input = chip && document.getElementById(chip.htmlFor);
    if (!input || input.type !== 'radio' || !input.checked) return;
    event.preventDefault(); // sonst wählt das Label die Antwort gleich wieder an
    input.checked = false;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Sortieren: Auswahl schickt das Formular ab ---------- */
  document.querySelectorAll('[data-auto-submit]').forEach((select) => {
    select.addEventListener('change', () => {
      if (isPreview) {
        announce('Vorschau: Sortieren funktioniert im echten Shop.');
        return;
      }
      select.form.submit();
    });
  });

  /* ---------- Hinweis im Hero: Gerät meldet "Bewegung reduzieren" ---------- */
  const systemReduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const html = document.documentElement;
  if (systemReduce && !html.classList.contains('motion-on') && !html.classList.contains('motion-off')) {
    document.querySelectorAll('[data-motion-hint]').forEach((hint) => (hint.hidden = false));
  }
  document.querySelectorAll('[data-motion-enable]').forEach((button) => {
    button.addEventListener('click', () => {
      try {
        localStorage.setItem('site-bewegung', 'an');
      } catch (error) {}
      html.classList.add('motion-on');
      html.classList.remove('motion-off');
      window.location.reload();
    });
  });

  /* ---------- Bewegung an/aus ---------- */
  document.querySelectorAll('[data-motion-toggle]').forEach((button) => {
    const update = () => {
      const off = reduceMotion.matches;
      button.setAttribute('aria-pressed', String(!off));
      button.querySelector('[data-motion-state]').textContent = off ? button.dataset.off : button.dataset.on;
    };
    button.addEventListener('click', () => {
      const html = document.documentElement;
      const turnOn = reduceMotion.matches;
      html.classList.toggle('motion-on', turnOn);
      html.classList.toggle('motion-off', !turnOn);
      try {
        localStorage.setItem('site-bewegung', turnOn ? 'an' : 'aus');
      } catch (error) {}
      update();
      window.location.reload();
    });
    update();
  });

  /* ---------- Warenkorbseite: Menge ändern speichert sofort ---------- */
  document.querySelectorAll('[data-cart-form]').forEach((form) => {
    let timer;
    form.addEventListener('change', (event) => {
      if (!event.target.matches('input[name="updates[]"]')) return;
      if (isPreview) {
        announce('Vorschau: Die Menge wird im echten Shop sofort gespeichert.');
        return;
      }
      window.clearTimeout(timer);
      timer = window.setTimeout(() => form.requestSubmit(form.querySelector('[name="update"]')), 450);
    });
  });
})();
